@if (showSplash && isMobile) {
  <div class="splash-screen">
    <div class="splash-inner">
      <div class="logo"></div>
    </div>
  </div>
}
